module.exports = __webpack_public_path__ + "static/media/FB231863-A7CD-4F96-A828-AAA3AF4F670E-removebg-preview.4f2dc7c2.png";